import { SegmentedControlVariantType } from '../../../../../components/segmentedControl/types/segmentedControlVariantType';
export const getSegmentedControlStyles = (FOUNDATIONS, FONT) => {
    return {
        [SegmentedControlVariantType.DEFAULT]: {
            rootContainer: {
                position: 'relative',
                display: 'flex',
                flex_direction: 'row',
                justify_content: 'center',
                padding: FOUNDATIONS.spacing_100,
                gap: FOUNDATIONS.spacing_100,
                border_radius: FOUNDATIONS.radius_comp_forms_segmentedcontrol_radiussize,
                border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_comp_forms_segmentedcontrol_border}`,
                background_color: FOUNDATIONS.color_comp_forms_segmentedcontrol_bg,
            },
            selectedTabBackgroundContainer: {
                position: 'absolute',
                background_color: FOUNDATIONS.color_comp_forms_segmentedcontrol_option_selected_bg,
                border_radius: FOUNDATIONS.radius_1000,
                transition: `left ${FOUNDATIONS.duration_150} ease-in-out`,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map